import React from 'react'
import cn from 'classnames'
import { Form } from 'util/ui'
import { propFunc } from 'util/functions'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import ValidatedField from 'shared/components/ui/ValidatedField'
import { TextDivider } from 'shared/ui'
import OAuthButton from 'components/OAuthButton'
import Button from '../../Button'
import SaveIndicator from '../../../sharedForm/SaveIndicator'
import sharedStyles from '../../../sharedForm/styles.less'

const googleTracking = {
  category: 'oAuth-onboarding',
  action: 'oAuth-account-creation',
  label: 'oAuth-creation-Gmail',
}

const officeTracking = {
  category: 'oAuth-onboarding',
  action: 'oAuth-account-creation',
  label: 'oAuth-creation-Office365',
}

class SignupForm extends React.PureComponent {
  state = {
    focusedField: null,
    oauthSignup: false,
  }

  componentDidMount() {
    const { redirectToHomeIfAuthenticated } = this.props
    redirectToHomeIfAuthenticated()
  }

  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    onChange(name, value, null, { validate: true })
  }

  handleFocus = name => {
    this.setState({ focusedField: name })
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    this.setState({ focusedField: null })
    onValidate(name, formFields[name])
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      canSave,
      saving,
      submitForm,
      doGoogleSignup,
      doOfficeSignup,
    } = this.props
    const { focusedField } = this.state
    return (
      <Form size="large" className={cn(sharedStyles.form, sharedStyles.formV2)}>
        <Form.Field>
          <label htmlFor="emailInput">Your work email address</label>
          <ValidatedField
            placeholder="Email address"
            name="emailInput"
            type="email"
            value={formFields.emailInput}
            errorMessage={
              focusedField !== 'emailInput' && formFieldsErrors.emailInput
            }
            onChange={propFunc(this.handleChange, 'emailInput')}
            onFocus={propFunc(this.handleFocus, 'emailInput')}
            onBlur={propFunc(this.handleBlur, 'emailInput')}
            fieldRefCallback={disableLastPassInputRef}
            autoFocus
          />
        </Form.Field>
        <Button id="signup-email" disabled={!canSave} onClick={submitForm}>
          {!saving ? (
            'Create your free account'
          ) : (
            <SaveIndicator animate>Creating account</SaveIndicator>
          )}
        </Button>
        <TextDivider>Or</TextDivider>
        <OAuthButton
          id="signup-google"
          key="google"
          onClick={doGoogleSignup}
          iconName="googleLogo"
          text="Sign up with Google"
          savingText="Signing up…"
          saving={saving}
          tracking={googleTracking}
        />
        <OAuthButton
          id="signup-office-365"
          key="office"
          onClick={doOfficeSignup}
          iconName="officeLogo"
          text="Sign up with Office 365"
          savingText="Signing up…"
          saving={saving}
          tracking={officeTracking}
        />
      </Form>
    )
  }
}

export default SignupForm
